



































































import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import userStaffType from '@/store/types/userStaff';
import { UserStaffParams } from '@/store/interfaces/staffUser';
import { nullToString } from '@/util/transformString/nullValidation';
import { VuexFunction } from '@/ts/axios';
import { itemsRoute, navLink } from '@/ts/navegationLinks';

@Component({
  name: 'ProfileStaff',
})
class ProfileStaff extends Vue {
  nullToString = nullToString;
  items: itemsRoute[] = [
    {
      id: 1,
      icon: 'fas fa-user',
      title: 'Datos',
      route: 'user-profile-staff',
    },
    {
      id: 2,
      icon: 'fas fa-lock',
      title: 'Permisos',
      route: 'user-staff-permissions',
    }
  ];

  navlink: navLink[] = [
    {
      name: 'Usuarios staff',
      active: false,
      to: '/staff',
    },
    {
      name: 'Perfil de usuario',
      active: true,
    }
  ];

  loading = true;

  async mounted(): Promise<void> {
    const user_id = this.$route.params.user_id;
    await this.singleUserStaff(user_id);
    this.$data.loading = false;
  }

  @Getter(`userStaff/${userStaffType.getters.GET_SINGLE_USER_STAFF}`)
  getUserStaff!: UserStaffParams;

  @Action(`userStaff/${userStaffType.actions.USER_SINGLE_STAFF}`)
  singleUserStaff!: VuexFunction;
}

export default ProfileStaff;
